import cleanedFilename from '~/util/cleanedFilename';

export default {
  ERROR_MESSAGE: `${cleanedFilename(__filename)}-error-message`,
  LOST_DEVICE_BUTTON: `${cleanedFilename(__filename)}-lost-device-button`,
  NEED_HELP_BUTTON: `${cleanedFilename(__filename)}-need-help-button`,
};
